const filterSelectFactory = (valueKey = 'label', removeSelected) => (options, filter, currentOptions) => {
  const optionsFilteredBySelection = removeSelected
    ? options.filter(
      option => !currentOptions || !currentOptions.find(currentOption => currentOption.value === option.value)
    )
    : options;

  if (!filter) {
    return optionsFilteredBySelection;
  }

  return optionsFilteredBySelection.filter(
    option => option[valueKey] && option[valueKey].toLowerCase().indexOf(filter.toLowerCase()) > -1
  );
};

export { filterSelectFactory };
